import { render, staticRenderFns } from "./redirectDialog.vue?vue&type=template&id=6901adc1&lang=pug"
import script from "./redirectDialog.vue?vue&type=script&lang=js"
export * from "./redirectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports